var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarteira(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00404F;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,5c0-1.4-1.2-2.6-2.6-2.6H4.1C2.7,2.4,1.6,3.6,1.6,5v1.3c0,0.1,0,0.1,0,0.1c0,0.1,0,0.2,0,0.3v3.3 c0,0.3,0.1,0.5,0.3,0.7C0.8,11.2,0,12.1,0,13.3v1.1c0,1.2,0.7,2.1,1.8,2.5c-0.1,0.2-0.2,0.4-0.2,0.6V21c0,1.4,1.2,2.6,2.6,2.6h19.3 c1.4,0,2.6-1.2,2.6-2.6V6.8c0-0.1,0-0.2,0-0.3c0-0.1,0-0.1,0-0.1V5z M2.1,13.3c0-0.3,0.2-0.5,0.5-0.5H3c-0.2,0.3-0.3,0.7-0.3,1.1 c0,0.4,0.1,0.8,0.3,1.1l-0.3,0c-0.3,0-0.5-0.2-0.5-0.5V13.3z M6.5,12.8h3.9c0.3,0,0.5,0.2,0.5,0.5v1.1c0,0.3-0.2,0.5-0.5,0.5l-3.9,0 c0.2-0.3,0.3-0.7,0.3-1.1C6.8,13.5,6.7,13.1,6.5,12.8z M23.9,21c0,0.2-0.2,0.4-0.4,0.4H4.1c-0.2,0-0.4-0.2-0.4-0.4v-3.4 c0-0.2,0-0.3-0.1-0.5h6.8c1.5,0,2.7-1.2,2.7-2.7v-1.1c0-1.5-1.2-2.7-2.7-2.7H3.6c0.1-0.2,0.2-0.3,0.2-0.5V6.8c0-0.2,0.2-0.4,0.4-0.4 h19.3c0.2,0,0.4,0.2,0.4,0.4V21z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarteira);
export default __webpack_public_path__ + "static/media/Carteira.57c7a19735640bcbc10584571bb302a3.svg";
export { ForwardRef as ReactComponent };